module.exports = __webpack_public_path__ + "media/application/images/2024/shapes/06-c30e341aebf9545dcec6dd2fa876654d.png";